module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado19.770aa4ec.svg";